import './screening-card.scss';
